import { useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import "./sales.css";
import AddButton from "../buttons/button";
import ShareTransactionModal from "../helper-components/share-popup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import errorToast from "../helper-components/error-toast";
import RadioButton from "../forms/radio-button";
import {
  tcsTaxListAction,
  tdsTaxListAction,
} from "../../redux/actions/settings-action";
import ItemsInputField from "../forms/items-input-field";
import ItemsSelectField from "../forms/items-select-field";
import { ChevronDown, ChevronUp } from "lucide-react";
import LoadingOverlay from "../helper-components/overlay-loading";
import { handleShowErrorToast } from "../helper-components/helper-function";

// Footer amounts always show 2 decimals (sums of float rates can otherwise
// display as 579.0000000000001).
const money = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
};

const SalesPurchaseFooter = ({
  name = "",
  disabled = false,
  page = "",
  EditFn = () => { },
  status = true,
  buttonLoading = false,
  transaction_type = "",
  transaction = "",
  prefixName = "",
  formValuesRef,
  handleBilling,
  validateDraft,

  modules = "purchase",
}) => {
  const header_inv_dis_per_ref = useRef();

  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { values, setFieldValue, errors } = useFormikContext();
  console.log(values, "dsdfdfsdfsdfsfsdfsdf");
  const [button, setButton] = useState("");
  const [isModalOpen, setIsModalOpen] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const submittingRef = useRef(false);
  const prevLoadingRef = useRef(false);

  useEffect(() => {
    if (buttonLoading) {
      submittingRef.current = true;
    } else if (prevLoadingRef.current) {
      submittingRef.current = false;
      setButton("");
    }
    prevLoadingRef.current = buttonLoading;
  }, [buttonLoading]);

  function checkErrors(errors) {
    if (!errors) return false;

    // 1. Check and show only the first top-level error
    const topLevelKeys = Object.keys(errors).filter((key) => key !== "data");
    for (const key of topLevelKeys) {
      const errorMsg = errors[key];
      if (typeof errorMsg === "string" && errorMsg.trim() !== "") {
        errorToast(errorMsg);
        return true;
      }
    }

    // 2. If no top-level error, check item_batches errors in data
    const batchesError = errors?.data?.find(
      (item) => item?.item_batches?.length > 0
    );

    if (batchesError) {
      errorToast("Please verify the batches of all items!");
      return true;
    }

    return false;
  }

  const [tcslist, setTcslist] = useState([]);
  const [tdslist, setTdslist] = useState([]);
  useEffect(() => {
    dispatch(tcsTaxListAction("", onSuccessTcs, onErrorTcs));
    dispatch(tdsTaxListAction("", onSuccessTds, onErrorTds));
  }, []);

  const onSuccessTcs = (data) => {
    setTcslist(
      data?.data?.map((item) => ({
        label: item?.tcs_name + " " + item?.tcs_percentage,
        value: item?.tcs_id,
        ...item,
      }))
    );
  };
  const onErrorTcs = (data) => { };
  const onSuccessTds = (data) => {
    setTdslist(
      data?.data?.map((item) => ({
        label: item?.tds_name + " " + item?.tds_percentage + "%",
        value: item?.tds_id,
        ...item,
      }))
    );
  };
  const onErrorTds = (data) => { };

  // useEffect(() => {
  //   return () => {
  //     const nextPath = location.pathname;
  //     if (nextPath.includes("/goods-receipt-csv")) {
  //       return;
  //     }

  //     if (
  //       formValuesRef?.current &&
  //       !formValuesRef?.current?.submittedButton &&
  //       !disabled &&
  //       (prefixName === "gort" || prefixName === "poit")
  //     ) {
  //       console.log(formValuesRef?.current, "formValuesRef?.current");

  //       handleBilling({
  //         ...formValuesRef?.current,
  //         submittedButton: "draft",
  //         save: "auto",
  //       });
  //     }
  //   };
  // }, [location]);
  useEffect(() => {
    return () => {
      const nextPath = location.pathname;
      if (nextPath.includes("/goods-receipt-csv")) return;

      const v = formValuesRef?.current;

      if (!v) return;
      if (v?.submittedButton) return; // already saved/draft/print clicked
      if (disabled) return;
      if (!(prefixName === "gort" || prefixName === "poit")) return;

      // ✅ prevent auto draft when only the blank row exists
      const items = Array.isArray(v?.data) ? v.data.slice(0, -1) : [];
      if (items.length === 0) return;

      handleBilling({
        ...v,
        submittedButton: "draft",
        save: "auto",
      });
    };
  }, [location.pathname]); // use pathname only
  const total_amount = values.data?.reduce(
    (total, item) => total + parseFloat(item.item_total_amount || 0),
    0
  );

  // Base amount the header discount is applied against, per line item: the
  // sum of that row's batch base rates (batch totals, quantity included).
  const headerBaseRateKey =
    modules === "purchase"
      ? "item_batch_scheme_purchase_rate"
      : "item_batch_total_base_sales_rate";
  // A purchase batch's scheme rate, as the batch panel defines it: total base
  // PR minus the scheme discount. Some documents (e.g. a cloned Purchase
  // Return) come back from the backend without the stored value, which made
  // every header-discount result 0 - rebuild it from the two fields that are
  // present instead.
  const getSchemePurchaseRate = (batch) => {
    const stored = parseFloat(batch?.item_batch_scheme_purchase_rate) || 0;
    if (stored > 0) return stored;
    return Math.max(
      0,
      (parseFloat(batch?.item_batch_total_base_purchase_rate) || 0) -
        (parseFloat(batch?.item_batch_scheme_discount_amount) || 0)
    );
  };
  const getBatchHeaderBase = (batch) =>
    modules === "purchase"
      ? getSchemePurchaseRate(batch)
      : parseFloat(batch?.[headerBaseRateKey]) || 0;
  const getRowHeaderBase = (row) =>
    (Array.isArray(row?.item_batches) ? row.item_batches : []).reduce(
      (sum, batch) => sum + getBatchHeaderBase(batch),
      0
    );

  // Splits a batch's tax the way the batch panel does: Inter-state is all
  // IGST, Intra-state is half CGST + half SGST. Driven by the document's
  // is_inter_state (the same flag the panel shows SGST/CGST vs IGST by).
  const getGstSplit = (taxAmount, taxPercentage) => {
    const isInter = values?.is_inter_state === true;
    return {
      item_batch_cgst_amount: isInter ? "0.00" : (taxAmount / 2).toFixed(2),
      item_batch_sgst_amount: isInter ? "0.00" : (taxAmount / 2).toFixed(2),
      item_batch_igst_amount: isInter ? taxAmount.toFixed(2) : "0.00",
      item_batch_cgst_percentage: isInter ? 0 : taxPercentage / 2,
      item_batch_sgst_percentage: isInter ? 0 : taxPercentage / 2,
      item_batch_igst_percentage: isInter ? taxPercentage : 0,
    };
  };

  // The header discount is always applied to the lines as a percentage - the
  // same rate comes off every line item. A ₹ amount entered by the user is
  // first converted to its % of the document (see applyHeaderDiscount).
  const onChangeHeaderDiscount = (
    discountPercentage,
    header_inv_dis_per,
    is_invoice_dis_percentage,
    type = ""
  ) => {
    let updatedData = [...values?.data];
    if (type === "header") {
      const headerDiscount = parseFloat(discountPercentage || 0);
      if (!Array.isArray(values.data) || isNaN(headerDiscount)) return;

      updatedData = values.data.map((row) => {
        if (row?.is_predefined_dis) {
          return row; // Skip predefined discounts
        }
        let updatedBatches = [];
        if (modules === "purchase") {
          console.log(modules, "dsfssfdsfsfdsdfsdfsfsdfsdfds");
          updatedBatches = Array.isArray(row?.item_batches)
            ? row.item_batches.map((batch) => {
              // Calculate scheme purchase rate
              const item_batch_scheme_purchase_rate =
                getSchemePurchaseRate(batch);
              // Apply header discount on scheme purchase rate
              const headerDiscountAmount =
                (item_batch_scheme_purchase_rate * headerDiscount) / 100;

              // Calculate discounted purchase rate
              const discountedPurchaseRate =
                parseFloat(item_batch_scheme_purchase_rate) -
                parseFloat(headerDiscountAmount);

              // Calculate tax
              const taxPercentage = parseFloat(
                batch.item_batch_tax_percentage || 0
              );
              const taxAmount =
                (discountedPurchaseRate * taxPercentage) / 100;

              // Calculate final purchase rate
              const totalEffectiveQuantity =
                // parseFloat, not parseInt: Purchase/Free Qty can be decimal
                // when the customization allows it.
                parseFloat(batch.item_sellable_quantity || 0) +
                parseFloat(batch.item_batch_free_quantity || 0);
              const finalPurchaseRate =
                totalEffectiveQuantity > 0
                  ? (discountedPurchaseRate + taxAmount) / totalEffectiveQuantity
                  : 0;

              // Calculate margin percentage
              const marginPercentage =
                (
                  ((parseFloat(batch.item_batch_unit_price || 0) -
                    finalPurchaseRate) /
                    finalPurchaseRate) *
                  100
                ).toFixed(2) || 0;

              // Same field meanings the batch panel uses: the general
              // discount is the header discount on the scheme rate, the total
              // discount is general + scheme, and the taxable amount is the
              // rate after both - otherwise the panel kept showing the
              // pre-discount taxable amount.
              const schemeDiscountAmount =
                parseFloat(batch?.item_batch_scheme_discount_amount) || 0;
              const purchaseRateBeforeTax =
                totalEffectiveQuantity > 0
                  ? discountedPurchaseRate / totalEffectiveQuantity
                  : 0;

              return {
                ...batch,
                item_batch_scheme_purchase_rate:
                  item_batch_scheme_purchase_rate.toFixed(2),
                item_batch_discount_percentage: headerDiscount,
                item_batch_gen_discount_amount: headerDiscountAmount.toFixed(2),
                item_batch_discount_amount: (
                  headerDiscountAmount + schemeDiscountAmount
                ).toFixed(2),
                item_batch_discounted_purchase_rate:
                  discountedPurchaseRate.toFixed(2),
                item_batch_taxable_amount: discountedPurchaseRate.toFixed(2),
                item_batch_purhcase_rate_before_tax:
                  purchaseRateBeforeTax.toFixed(2),
                item_batch_tax_amount: taxAmount.toFixed(2),
                item_batch_total_purchase_rate: (
                  discountedPurchaseRate + taxAmount
                ).toFixed(2),
                item_batch_final_purchase_rate: finalPurchaseRate.toFixed(2),
                item_batch_margin_percentage: marginPercentage,
                ...getGstSplit(taxAmount, taxPercentage),
              };
            })
            : [];
        } else if (modules === "sales") {
          updatedBatches = Array.isArray(row?.item_batches)
            ? row.item_batches.map((batch) => {
              console.log(batch, "dsfssfdsfsfdsdfsdfsfsdfsdfds");

              // Calculate scheme sales rate
              const item_batch_total_base_sales_rate =
                parseFloat(batch?.item_batch_total_base_sales_rate) || 0;
              // Apply header discount on scheme sales rate
              const headerDiscountAmount =
                (item_batch_total_base_sales_rate * headerDiscount) / 100;

              // Calculate discounted sales rate
              const discountedSalesRate =
                item_batch_total_base_sales_rate - headerDiscountAmount;

              // Calculate tax
              const taxPercentage = parseFloat(
                batch.item_batch_tax_percentage || 0
              );
              const taxAmount = (discountedSalesRate * taxPercentage) / 100;

              // Calculate final sales rate
              const totalEffectiveQuantity =
                parseInt(batch.item_batch_quantity || 0) +
                parseInt(batch.item_batch_free_quantity || 0);

              const totalSalesRate =
                parseFloat(discountedSalesRate) + parseFloat(taxAmount);
              const finalSalesRate =
                totalEffectiveQuantity > 0
                  ? totalSalesRate / totalEffectiveQuantity
                  : 0;

              // Calculate margin percentage
              const marginPercentage =
                (
                  ((parseFloat(batch.item_batch_unit_price || 0) -
                    finalSalesRate) /
                    (finalSalesRate || 1)) *
                  100
                ).toFixed(2) || 0;

              return {
                ...batch,
                item_batch_discount_percentage: headerDiscount,
                item_batch_discount_amount: headerDiscountAmount.toFixed(2),
                item_batch_tax_amount: taxAmount.toFixed(2),
                item_batch_total_sales_rate: totalSalesRate.toFixed(2),
                item_batch_final_sales_rate: finalSalesRate.toFixed(2),
                item_batch_margin_percentage: marginPercentage,
                ...getGstSplit(taxAmount, taxPercentage),
              };
            })
            : [];
        }

        // Align batch totals to the row
        const rowTotalDiscount = updatedBatches.reduce(
          (total, batch) =>
            total + parseFloat(batch.item_batch_discount_amount || 0),
          0
        );
        const rowTotalTax = updatedBatches.reduce(
          (total, batch) =>
            total + parseFloat(batch.item_batch_tax_amount || 0),
          0
        );
        const rowTotalAmount = updatedBatches.reduce(
          (total, batch) =>
            total +
            parseFloat(
              batch.item_batch_total_purchase_rate ||
              batch.item_batch_total_sales_rate ||
              0
            ),
          0
        );

        return {
          ...row,
          item_batches: updatedBatches,
          item_discount_amount: rowTotalDiscount?.toFixed(2),
          item_tax_amount: rowTotalTax?.toFixed(2),
          item_total_amount: rowTotalAmount?.toFixed(2),
        };
      });

      setFieldValue("data", updatedData);
    }

    // Calculate base total (after item discounts, before invoice discount)
    let baseTotal = updatedData.reduce(
      (total, item) => total + parseFloat(item.item_total_amount || 0),
      0
    );
    const total_tax = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_tax_amount) || 0);
    }, 0);

    const total_discount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_discount_amount) || 0);
    }, 0);

    const sub_total = (baseTotal - total_tax + total_discount).toFixed(2);

    // --- TCS/TDS Calculation ---
    let tcs_tds_amount = 0;
    let tcs_tds_percentage = 0;
    let finalTotal = baseTotal;
    let round_off_value = 0;

    const tcs_tds_type = values?.[`${prefixName}_tds_tcs_type`];
    const tcs_tds_percentage_val =
      values?.[`${prefixName}_tcs_or_tds_percentage`] || 0;

    if (tcs_tds_type === "tcs") {
      tcs_tds_percentage = parseFloat(tcs_tds_percentage_val);
      tcs_tds_amount = baseTotal * (tcs_tds_percentage / 100);
      finalTotal = baseTotal + tcs_tds_amount;
    } else if (tcs_tds_type === "tds") {
      tcs_tds_percentage = parseFloat(tcs_tds_percentage_val);
      const gst_total = parseFloat(values?.gort_total_gst || 0);
      const taxableAmount = baseTotal - gst_total;
      tcs_tds_amount = taxableAmount * (tcs_tds_percentage / 100);
      finalTotal = baseTotal - tcs_tds_amount;
    }

    const invoice_discount = is_invoice_dis_percentage
      ? (finalTotal * header_inv_dis_per) / 100
      : header_inv_dis_per;

    const invoice_discount_percentage = is_invoice_dis_percentage
      ? header_inv_dis_per
      : finalTotal > 0
        ? (header_inv_dis_per / finalTotal) * 100
        : 0;

    const total_after_inv_discount =
      finalTotal - parseFloat(invoice_discount || 0);

    const rounded_total = Math.round(total_after_inv_discount).toFixed(2);
    round_off_value = (rounded_total - total_after_inv_discount).toFixed(2);
    setFieldValue(`${prefixName}_sub_total`, sub_total);
    setFieldValue(`${prefixName}_total_gst`, total_tax);
    setFieldValue(`${prefixName}_total_discount`, total_discount);
    setFieldValue(`${prefixName}_total_amount`, rounded_total);
    setFieldValue(`${prefixName}_round_off_value`, round_off_value);
    setFieldValue(
      `${prefixName}_invoice_discount`,
      invoice_discount?.toFixed(2)
    );
    setFieldValue(
      `${prefixName}_invoice_discount_percentage`,
      invoice_discount_percentage
    );
    setFieldValue(`${prefixName}_tcs_or_tds_amount`, tcs_tds_amount.toFixed(2));
    setFieldValue(`${prefixName}_tcs_or_tds_percentage`, tcs_tds_percentage);
  };

  // Total the header discount is taken from: every line's base amount,
  // leaving out lines that carry a predefined discount.
  const getHeaderDiscountBase = () =>
    (Array.isArray(values?.data) ? values.data : []).reduce(
      (sum, row) => (row?.is_predefined_dis ? sum : sum + getRowHeaderBase(row)),
      0
    );

  // What the header discount boxes last showed after applying, so a blur
  // without an edit (e.g. tabbing through) doesn't re-apply the discount.
  const lastHeaderDiscountRef = useRef({ per: "", amt: "" });
  // Both boxes empty means the form was reset (e.g. after save) - forget the
  // last applied value, or typing that same value again would be skipped.
  useEffect(() => {
    if (
      `${values?.header_dis_per ?? ""}` === "" &&
      `${values?.header_dis_amt ?? ""}` === ""
    ) {
      lastHeaderDiscountRef.current = { per: "", amt: "" };
    }
  }, [values?.header_dis_per, values?.header_dis_amt]);

  // The header discount has two linked boxes: % and ₹. Whichever one the
  // user types in, the other is filled with its equivalent, and only the %
  // goes to the lines. ₹ is the amount off the whole document, so it's
  // turned into its % of the header discount base - ₹100 on a ₹1,000 bill is
  // 10% off every line, not ₹100 off each line.
  const applyHeaderDiscount = (source, rawValue, showToast) => {
    const base = getHeaderDiscountBase();
    const isEmpty = `${rawValue ?? ""}`.trim() === "";
    let entered = parseFloat(rawValue);
    if (isNaN(entered)) entered = 0;

    // A negative discount is allowed (it adds to the lines instead of taking
    // off), so only the upper limit is enforced.
    const max = source === "per" ? 100 : base;
    if (entered > max) {
      if (showToast) {
        errorToast(
          `Header discount cannot be more than ${
            source === "per" ? "100%" : `₹${max.toFixed(2)}`
          }. Setting to maximum.`
        );
      }
      entered = max;
    }

    const percentage =
      source === "per" ? entered : base > 0 ? (entered / base) * 100 : 0;
    const amount = source === "amt" ? entered : (base * percentage) / 100;

    // Clearing the box removes the discount and empties both boxes.
    const shownPer = isEmpty ? "" : source === "per" ? entered : +percentage.toFixed(2);
    const shownAmt = isEmpty ? "" : source === "amt" ? entered : +amount.toFixed(2);
    setFieldValue("header_dis_per", shownPer);
    setFieldValue("header_dis_amt", shownAmt);
    lastHeaderDiscountRef.current = { per: `${shownPer}`, amt: `${shownAmt}` };

    onChangeHeaderDiscount(
      percentage,
      parseFloat(values?.header_inv_dis_per || 0),
      values?.[`${prefixName}_is_invoice_dis_percentage`],
      "header"
    );
  };

  // Borderless inputs - the shared header discount box draws the border.
  const headerDiscountInputClass =
    "w-full h-[38px] px-2 border-0 bg-transparent focus:outline-none text-[var(--items-search-input-color)] text-[length:var(--items-search-input-font-size)] font-[var(--items-search-input-font-weight)] input-field-no-spin-buttons";

  const headerDiscountInputProps = (source) => ({
    type: "number",
    disabled,
    isLabelReq: false,
    onKeyDown: (event) => {
      if (event.key === "Tab" || event.key === "Enter") {
        if (`${event.target.value}` !== lastHeaderDiscountRef.current[source]) {
          applyHeaderDiscount(source, event.target.value, true);
        }
        // Only Enter jumps straight to the Inv Adjustment input (fast
        // keyboard-entry flow); Tab keeps the browser's native tab order.
        if (event.key === "Enter") {
          header_inv_dis_per_ref?.current.focus();
        }
      }
    },
    onBlur: (event) => {
      if (`${event.target.value}` === lastHeaderDiscountRef.current[source]) {
        return;
      }
      applyHeaderDiscount(source, event.target.value, false);
    },
  });

  //   let hasError = false;
  //   let errorMessages = [];

  //   const ordinalSuffixes = ["st", "nd", "rd"];

  //   data?.forEach((item, index) => {
  //     console.log(
  //       "qqq",
  //       item?.selected_uom_qty,
  //       item?.item_pur_min_uom_quantity,
  //       item?.quantity
  //     );
  //     if (
  //       item?.selected_uom_qty &&
  //       item?.item_pur_min_uom_quantity &&
  //       item?.quantity
  //     ) {
  //       const actualQuantity = item.selected_uom_qty * item.quantity;
  //       const minimumRequired = item.item_pur_min_uom_quantity;
  //       console.log("oooo", actualQuantity < minimumRequired);

  //       if (actualQuantity < minimumRequired) {
  //         hasError = true;
  //         const suffix = index < 3 ? ordinalSuffixes[index] : "th";
  //         const itemPosition = index + 1;

  //         errorToast(
  //           `Minimum quantity of ${itemPosition}${suffix} item should be ${minimumRequired}`
  //         );
  //       }
  //     }
  //   });
  //   return hasError;
  // };

  return (
    <div className="h-[8rem] bg-white relative z-50">
      <div className="h-[4rem] border-y border-[var(--create-table-footer-border)] flex items-center justify-between">
        <div className="flex w-[80%] h-full">
          <div className="w-[27%] px-5 border-r border-r-[var(--create-table-footer-border)] h-full flex items-center">
            <ItemsInputField
              maxLength={250}
              disabled={disabled && page !== "edit"}
              name={`remarks`}
              isLabelReq={false}
              allowAll={true}
              placeholder="Enter your remarks here..."
            />
          </div>

          <div className="w-[38%] px-5 border-r border-r-[var(--create-table-footer-border)] h-full flex gap-3 items-center">
            {transaction_type !== "sales_order" &&
              transaction_type !== "purchase_order" && (
                <>
                  {page !== "view" && (
                    // One box for the header discount: % OR ₹. Typing in
                    // either side fills the other (see applyHeaderDiscount).
                    <div
                      className={`flex-[3] min-w-0 box-border h-[40px] flex items-center overflow-hidden border border-[var(--items-search-input-border)] focus-within:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)] border-radius ${
                        disabled ? "opacity-60" : ""
                      }`}
                      title="Header discount - enter % or ₹; only the % is applied to every line"
                    >
                      <div className="flex-1 min-w-0">
                        <ItemsInputField
                          {...headerDiscountInputProps("per")}
                          name={`header_dis_per`}
                          placeholder="Disc"
                          inputClass={headerDiscountInputClass}
                        />
                      </div>
                      <span className="text-[var(--items-search-input-color)] text-sm px-1">
                        %
                      </span>
                      <span className="shrink-0 mx-1 px-1.5 py-0.5 rounded-full bg-[var(--trans-stats-con-blue-bg)] text-[var(--primary-button-bg-color)] text-[10px] font-semibold leading-none">

                        OR
                      </span>
                      <span className="text-[var(--items-search-input-color)] text-sm px-1">
                        ₹
                      </span>
                      <div className="flex-1 min-w-0">
                        <ItemsInputField
                          {...headerDiscountInputProps("amt")}
                          name={`header_dis_amt`}
                          placeholder="Amount"
                          inputClass={headerDiscountInputClass}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className={`${page === "view" ? "w-[100%]" : "flex-[2] min-w-0"
                      }  relative`}
                  >
                    <ItemsInputField
                      type="number"
                      ref={header_inv_dis_per_ref}
                      disabled={disabled || values?.data?.length === 0}
                      name={`header_inv_dis_per`}
                      isLabelReq={false}
                      placeholder={`Inv Adjustment ${values?.[`${prefixName}_is_invoice_dis_percentage`]
                        ? "%"
                        : "₹"
                        }`}
                      onKeyDown={(event) => {
                        if (event.key === "Tab" || event.key === "Enter") {
                          let val = parseFloat(event.target.value || 0);
                          const total_without_inv_dis =
                            parseFloat(
                              values?.data?.reduce(
                                (total, item) =>
                                  total +
                                  parseFloat(item.item_total_amount || 0),
                                0
                              )
                            ) || 0;

                          if (
                            values?.[`${prefixName}_is_invoice_dis_percentage`]
                          ) {
                            // Percentage mode
                            const min = 0;
                            const max = 100;
                            if (val < min) {
                              errorToast(
                                `Invoice discount cannot be less than ${min}%. Setting to minimum.`
                              );
                              setFieldValue("header_inv_dis_per", min);
                              val = min;
                            } else if (val > max) {
                              errorToast(
                                `Invoice discount cannot be more than ${max}%. Setting to maximum.`
                              );
                              setFieldValue("header_inv_dis_per", max);
                              val = max;
                            }
                          } else {
                            // Amount mode: convert to percentage and validate
                            const minPer = 0;
                            const maxPer = 100;
                            const percent =
                              total_without_inv_dis > 0
                                ? (val / total_without_inv_dis) * 100
                                : 0;
                            if (percent < minPer) {
                              errorToast(
                                `Invoice discount cannot be less than ${minPer}% of subtotal. Setting to minimum.`
                              );
                              const minVal =
                                (minPer / 100) * total_without_inv_dis;
                              setFieldValue("header_inv_dis_per", minVal);
                              val = minVal;
                            } else if (percent > maxPer) {
                              errorToast(
                                `Invoice discount cannot be more than ${maxPer}% of subtotal. Setting to maximum.`
                              );
                              const maxVal =
                                (maxPer / 100) * total_without_inv_dis;
                              setFieldValue("header_inv_dis_per", maxVal);
                              val = maxVal;
                            }
                          }
                          onChangeHeaderDiscount(
                            parseFloat(values?.header_dis_per || 0),
                            val,
                            values?.[`${prefixName}_is_invoice_dis_percentage`]
                          );
                        }
                      }}
                      onBlur={(event) => {
                        let val = parseFloat(event.target.value || 0);
                        const total_without_inv_dis =
                          parseFloat(
                            values?.data?.reduce(
                              (total, item) =>
                                total + parseFloat(item.item_total_amount || 0),
                              0
                            )
                          ) || 0;
                        if (
                          values?.[`${prefixName}_is_invoice_dis_percentage`]
                        ) {
                          // Percentage mode
                          const min = 0;
                          const max = 100;
                          if (val < min) {
                            setFieldValue("header_inv_dis_per", min);
                            val = min;
                          } else if (val > max) {
                            setFieldValue("header_inv_dis_per", max);
                            val = max;
                          }
                        } else {
                          // Amount mode: convert to percentage and validate
                          const minPer = 0;
                          const maxPer = 100;
                          const percent =
                            total_without_inv_dis > 0
                              ? (val / total_without_inv_dis) * 100
                              : 0;
                          if (percent < minPer) {
                            const minVal =
                              (minPer / 100) * total_without_inv_dis;
                            setFieldValue("header_inv_dis_per", minVal);
                            val = minVal;
                          } else if (percent > maxPer) {
                            const maxVal =
                              (maxPer / 100) * total_without_inv_dis;
                            setFieldValue("header_inv_dis_per", maxVal);
                            val = maxVal;
                          }
                        }
                        onChangeHeaderDiscount(
                          parseFloat(values?.header_dis_per || 0),
                          val,
                          values?.[`${prefixName}_is_invoice_dis_percentage`]
                        );
                      }}
                    />
                    <button
                      disabled={disabled}
                      onClick={() => {
                        setFieldValue(
                          `${prefixName}_is_invoice_dis_percentage`,
                          !values?.[`${prefixName}_is_invoice_dis_percentage`]
                        );
                        setFieldValue("header_inv_dis_per", "");
                        onChangeHeaderDiscount(
                          parseFloat(values?.header_dis_per),
                          // parseFloat(values?.header_inv_dis_per),
                          0,
                          !values?.[`${prefixName}_is_invoice_dis_percentage`]
                        );
                      }}
                      type="button"
                      className="absolute top-1/2 -translate-y-1/2 right-0 w-[40px] min-h-[40px] flex items-center justify-center bg-[var(--create-tab-foot-subTot-bg)] border border-[var(--items-search-input-border)] rounded-r"
                    >
                      {values?.[`${prefixName}_is_invoice_dis_percentage`]
                        ? "%"
                        : "₹"}
                    </button>
                  </div>
                </>
              )}
          </div>
          <div className="w-[35%] px-5 border-r border-r-[var(--create-table-footer-border)] h-full flex items-center gap-3 justify-between">
            <div className="w-[30%]">
              {transaction_type !== "sales_order" &&
                transaction_type !== "purchase_order" && (
                  <RadioButton
                    disabled={disabled}
                    onChange={(sel) => {
                      if (sel?.target?.value === "tcs") {
                        const percentage = tcslist?.find(
                          (item) => item?.tcs_id === values?.cmr_tcs
                        )?.tcs_percentage;

                        const tcsvalue =
                          parseFloat(total_amount) *
                          (parseFloat(percentage || 0) / 100);

                        const actualTotal = parseFloat(total_amount) + tcsvalue;
                        const finalTotal = Math.round(actualTotal).toFixed(2);
                        const round_off_value = (
                          finalTotal - actualTotal
                        ).toFixed(2);

                        setFieldValue(
                          `${prefixName}_tds_tcs_type`,
                          sel?.target?.value
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_percentage_id`,
                          values?.cmr_tcs ?? ""
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_percentage`,
                          percentage ?? 0
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_amount`,
                          tcsvalue.toFixed(2)
                        );
                        setFieldValue(`${prefixName}_total_amount`, finalTotal);
                        setFieldValue(
                          `${prefixName}_round_off_value`,
                          round_off_value
                        );

                        setFieldValue(`${prefixName}_invoice_discount`, 0);
                        setFieldValue(
                          `${prefixName}_invoice_discount_percentage`,
                          0
                        );
                        setFieldValue("header_inv_dis_per", "");
                      } else if (sel?.target?.value === "tds") {
                        const percentage = tdslist?.find(
                          (item) => item?.tds_id === values?.cmr_tds
                        )?.tds_percentage;

                        const taxableAmount =
                          parseFloat(total_amount) -
                          parseFloat(values?.gort_total_gst || 0);

                        const tdsvalue =
                          taxableAmount * (parseFloat(percentage || 0) / 100);

                        const actualTotal = parseFloat(total_amount) - tdsvalue;
                        const finalTotal = Math.round(actualTotal).toFixed(2);
                        const round_off_value = (
                          finalTotal - actualTotal
                        ).toFixed(2);

                        setFieldValue(
                          `${prefixName}_tds_tcs_type`,
                          sel?.target?.value
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_percentage_id`,
                          values?.cmr_tds ?? ""
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_percentage`,
                          percentage ?? 0
                        );
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_amount`,
                          tdsvalue.toFixed(2)
                        );
                        setFieldValue(`${prefixName}_total_amount`, finalTotal);
                        setFieldValue(
                          `${prefixName}_round_off_value`,
                          round_off_value
                        );
                        setFieldValue(`${prefixName}_invoice_discount`, 0);
                        setFieldValue(
                          `${prefixName}_invoice_discount_percentage`,
                          0
                        );
                        setFieldValue("header_inv_dis_per", "");
                      }
                    }}
                    onClick={(e) => {
                      if (
                        e?.target?.value ===
                        values?.[`${prefixName}_tds_tcs_type`]
                      ) {
                        const final_total_amount =
                          Math.round(total_amount).toFixed(2);
                        const round_off_value = (
                          Math.round(total_amount) - total_amount
                        ).toFixed(2);
                        setFieldValue(
                          `${prefixName}_tcs_or_tds_percentage_id`,
                          ""
                        );
                        setFieldValue(`${prefixName}_tds_tcs_type`, "");
                        setFieldValue(`${prefixName}_tcs_or_tds_percentage`, 0);
                        setFieldValue(`${prefixName}_tcs_or_tds_amount`, 0);
                        setFieldValue(
                          `${prefixName}_round_off_value`,
                          round_off_value
                        );
                        setFieldValue(
                          `${prefixName}_total_amount`,
                          final_total_amount
                        );
                        setFieldValue(`${prefixName}_invoice_discount`, 0);
                        setFieldValue(
                          `${prefixName}_invoice_discount_percentage`,
                          0
                        );
                        setFieldValue("header_inv_dis_per", "");
                      }
                    }}
                    mainContainerClass="flex gap-5"
                    inputLabelClass="  focus:outline-none focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)] text-[var(--items-search-input-color)] text-[length:var(--items-search-input-font-size)] font-[var(--items-search-input-font-weight)] border-radius "
                    name={`${prefixName}_tds_tcs_type`}
                    // labelClass=""
                    options={tcsTdsOptns}
                    label=""
                  // buttonContainerClass=""
                  />
                )}
            </div>

            {values?.[`${prefixName}_tds_tcs_type`] && (
              <div className="w-[60%]">
                <ItemsSelectField
                  handleSelect={(sel) => {
                    if (values?.[`${prefixName}_tds_tcs_type`] === "tcs") {
                      const tcsvalue =
                        parseFloat(total_amount) *
                        (parseFloat(sel?.tcs_percentage || 0) / 100);

                      const actualTotal = parseFloat(total_amount) + tcsvalue;
                      const finalTotal = Math.round(actualTotal);
                      const round_off_value = (
                        finalTotal - actualTotal
                      ).toFixed(2);

                      setFieldValue(
                        `${prefixName}_tcs_or_tds_percentage`,
                        sel?.tcs_percentage || 0
                      );

                      setFieldValue(
                        `${prefixName}_tcs_or_tds_amount`,
                        tcsvalue.toFixed(2)
                      );
                      setFieldValue(`${prefixName}_total_amount`, finalTotal);
                      setFieldValue(
                        `${prefixName}_round_off_value`,
                        round_off_value
                      );
                      setFieldValue(`${prefixName}_invoice_discount`, 0);
                      setFieldValue(
                        `${prefixName}_invoice_discount_percentage`,
                        0
                      );
                      setFieldValue("header_inv_dis_per", "");
                    } else if (
                      values?.[`${prefixName}_tds_tcs_type`] === "tds"
                    ) {
                      const taxableAmount =
                        parseFloat(total_amount) -
                        parseFloat(values?.gort_total_gst || 0);

                      const tdsvalue =
                        taxableAmount *
                        (parseFloat(sel?.tds_percentage || 0) / 100);

                      const actualTotal = parseFloat(total_amount) - tdsvalue;
                      const finalTotal = Math.round(actualTotal);
                      const round_off_value = (
                        finalTotal - actualTotal
                      ).toFixed(2);
                      setFieldValue(
                        `${prefixName}_tcs_or_tds_percentage`,
                        sel?.tds_percentage || 0
                      );

                      setFieldValue(
                        `${prefixName}_tcs_or_tds_amount`,
                        tdsvalue.toFixed(2)
                      );
                      setFieldValue(`${prefixName}_total_amount`, finalTotal);
                      setFieldValue(
                        `${prefixName}_round_off_value`,
                        round_off_value
                      );
                      setFieldValue(`${prefixName}_invoice_discount`, 0);
                      setFieldValue(
                        `${prefixName}_invoice_discount_percentage`,
                        0
                      );
                      setFieldValue("header_inv_dis_per", "");
                    }
                  }}
                  disabled={disabled}
                  isCreatable={true}
                  options={
                    values?.[`${prefixName}_tds_tcs_type`] === "tcs"
                      ? tcslist
                      : tdslist
                  }
                  name={`${prefixName}_tcs_or_tds_percentage_id`}
                  isLabelReq={false}
                  placeholder="Select "
                />
              </div>
            )}
          </div>
        </div>

        <div
          className="justify-between w-[20%] px-5 h-full flex flex-col items-center
      bg-[var(--create-table-footer-totals-bg)] text-[var(--create-table-footer-totals-fg)]
      text-[length:var(--create-table-footer-totals-fs)] font-[var(--create-table-footer-totals-fw)] relative"
        >
          {/* Toggle Button */}
          {!isOpen && (
            <div
              className="absolute top-[-1.2rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-table-footer-totals-bg)] cursor-pointer 
                    flex items-start justify-center"
              style={{
                width: "80px",
                height: "55px",
                borderRadius: "9999px", // makes it oval
                padding: "0.2rem",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
            </div>
          )}
          {isOpen && (
            <div
              className="p-5 flex flex-col w-full space-y-5 absolute bottom-[100%]"
              style={{
                backgroundColor: "var(--create-tab-foot-subTot-bg)",
                color: "var(--create-tab-foot-subTot-fg)",
                fontSize: "var(--create-tab-foot-subTot-fs)",
                fontWeight: "var(--create-tab-foot-subTot-fw)",
              }}
            >
              <div className="flex justify-between">
                <span>Sub Total</span>
                <span>₹{money(values?.[`${prefixName}_sub_total`])}</span>
              </div>
              <div className="flex justify-between">
                <span>Tax</span>
                <span style={{ color: "var(--error-color)" }}>
                  ₹{money(values?.[`${prefixName}_total_gst`])}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Discount</span>
                <span style={{ color: "var(--success-color)" }}>
                  {" - "}₹{money(values?.[`${prefixName}_total_discount`])}
                </span>
              </div>
              {prefixName !== "pot" && prefixName !== "sott" && (
                <div className="flex justify-between items-center">
                  <span>
                    {" "}
                    {values?.[`${prefixName}_tds_tcs_type`] === "tcs"
                      ? "TCS "
                      : values?.[`${prefixName}_tds_tcs_type`] === "tds"
                        ? "TDS"
                        : "TCS/TDS "}
                    <span className="text-xsm">
                      {" "}
                      {`(${parseFloat(
                        values?.[`${prefixName}_tcs_or_tds_percentage`]
                      ).toFixed(2)} %)`}
                    </span>
                  </span>
                  <span style={{ color: "var(--success-color)" }}>
                    {values?.[`${prefixName}_tds_tcs_type`] === "tds"
                      ? " - "
                      : ""}
                    <input
                      disabled={
                        disabled || !values?.[`${prefixName}_tds_tcs_type`]
                      }
                      className={`text-end w-[7rem] h-[34px] px-2  border rounded-[8px] border-[var(--create-tab-foot-input-border)] ${values?.[`${prefixName}_tds_tcs_type`] === "tcs"
                        ? "text-[var(--error-color)]"
                        : "text-[var(--success-color)]"
                        }`}
                      type="text"
                      value={values?.[`${prefixName}_tcs_or_tds_amount`]}
                      onChange={(e) => {
                        const enteredAmount = parseFloat(e.target.value) || 0;
                        let updatedPercentage = 0;

                        if (values?.[`${prefixName}_tds_tcs_type`] === "tcs") {
                          const totalAmount = parseFloat(total_amount) || 1;
                          updatedPercentage =
                            (enteredAmount / totalAmount) * 100;
                          const actualTotal =
                            parseFloat(total_amount) + enteredAmount;
                          const finalTotal = Math.round(actualTotal).toFixed(2);
                          const round_off_value = (
                            finalTotal - actualTotal
                          ).toFixed(2);
                          setFieldValue(
                            `${prefixName}_tcs_or_tds_percentage`,
                            updatedPercentage.toFixed(2)
                          );
                          setFieldValue(
                            `${prefixName}_tcs_or_tds_amount`,
                            enteredAmount
                          );
                          setFieldValue(
                            `${prefixName}_total_amount`,
                            finalTotal
                          );
                          setFieldValue(
                            `${prefixName}_round_off_value`,
                            round_off_value
                          );
                        } else {
                          const totalWithoutTax =
                            total_amount - parseFloat(values?.gort_total_gst);

                          updatedPercentage =
                            (enteredAmount / (totalWithoutTax || 1)) * 100;

                          const actualTotal =
                            parseFloat(total_amount) - enteredAmount;
                          const finalTotal = Math.round(actualTotal).toFixed(2);
                          const round_off_value = (
                            finalTotal - actualTotal
                          ).toFixed(2);

                          setFieldValue(
                            `${prefixName}_tcs_or_tds_percentage`,
                            updatedPercentage.toFixed(2)
                          );
                          setFieldValue(
                            `${prefixName}_tcs_or_tds_amount`,
                            enteredAmount
                          );
                          setFieldValue(
                            `${prefixName}_total_amount`,
                            finalTotal
                          );
                          setFieldValue(
                            `${prefixName}_round_off_value`,
                            round_off_value
                          );
                        }
                      }}
                    />
                  </span>
                </div>
              )}

              {prefixName !== "pot" && prefixName !== "sott" && (
                <div className="flex justify-between">
                  <span>Invoice Adjustment</span>
                  <span style={{ color: "var(--success-color)" }}>
                    {" - "}₹
                    {values?.[`${prefixName}_invoice_discount`] || "0.00"}
                  </span>
                </div>
              )}

              <div className="flex justify-between">
                <span>Round off</span>
                <span
                  className={
                    parseFloat(values?.[`${prefixName}_round_off_value`] || 0) >
                      0
                      ? "text-[var(--error-color)]"
                      : parseFloat(
                        values?.[`${prefixName}_round_off_value`] || 0
                      ) < 0
                        ? "text-[var(--success-color)]"
                        : ""
                  }
                >
                  ₹
                  {parseFloat(
                    values?.[`${prefixName}_round_off_value`] || 0
                  ).toFixed(2)}
                </span>
              </div>

              <div
                className={`absolute top-[-2.3rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-tab-foot-subTot-bg)] cursor-pointer 
              flex items-start justify-center `}
                style={{
                  width: "80px",
                  height: "55px",
                  borderRadius: "9999px", // makes it oval
                  padding: "0.2rem",
                }}
                onClick={() => setIsOpen(!isOpen)}
              >
                {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
              </div>
            </div>
          )}

          {/* Total Amount */}
          <div className="flex justify-between w-full h-full items-center">
            <span>Total</span>
            <span>₹{values?.[`${prefixName}_total_amount`] || "0.00"}</span>
          </div>
        </div>
      </div>

      <div className="h-[4rem] flex justify-between px-5">
        <div></div>
        <div className="flex gap-3 items-center">
          {page !== "view" && (
            <>
              {" "}
              <AddButton
                spinnerClass="h-6 w-6 border-t-2 border-[var(--primary-button-bg-color)]"
                isDisabled={buttonLoading}
                loading={buttonLoading && button === "draft"}
                prefixIcon={false}
                text={"Draft"}
                className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--draft-button-bg)] cursor-pointer
text-[var(--draft-button-fg)]
border border-[var(--draft-button-border)]
text-[length:var(--draft-button-fs)]
font-[var(--draft-button-fw)]
"
                type="submit"
                onclkFn={(e) => {
                  if (buttonLoading || submittingRef.current) return;
                  if (
                    validateDraft &&
                    !validateDraft({ ...values, submittedButton: "draft" })
                  ) {
                    e.preventDefault();
                    return;
                  }
                  submittingRef.current = true;
                  setFieldValue("submittedButton", "draft");
                  setButton("draft");
                  setTimeout(() => {
                    if (!prevLoadingRef.current) {
                      submittingRef.current = false;
                    }
                  }, 1500);
                }}
              />{" "}
              <AddButton
                isDisabled={buttonLoading}
                loading={buttonLoading && button === "save"}
                onclkFn={() => {
                  if (buttonLoading || submittingRef.current) return;
                  submittingRef.current = true;
                  checkErrors(errors);
                  if (errors?.data && Array.isArray(errors.data)) {
                    errors.data.forEach((rowError, idx) => {
                      if (rowError?.mrp) {
                        if (idx === errors.data.length - 1) return;
                        errorToast(`Row ${idx + 1}: ${rowError.mrp}`);
                      }
                    });
                  }
                  setFieldValue("submittedButton", "save");
                  setButton("save");
                  setTimeout(() => {
                    if (!prevLoadingRef.current) {
                      submittingRef.current = false;
                    }
                  }, 1500);
                }}
                prefixIcon={false}
                text={"Save"}
                className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)]
font-[var(--primary-button-font-weight)]
"
                type="submit"
              />
              <AddButton
                isDisabled={buttonLoading}
                loading={buttonLoading && button === "print"}
                onclkFn={() => {
                  if (buttonLoading || submittingRef.current) return;
                  submittingRef.current = true;
                  checkErrors(errors);
                  setFieldValue("submittedButton", "print");
                  setButton("print");
                  setTimeout(() => {
                    if (!prevLoadingRef.current) {
                      submittingRef.current = false;
                    }
                  }, 1500);
                }}
                prefixIcon={false}
                text={"Save and Print"}
                className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]
"
                type="submit"
              />
            </>
          )}

          {page === "view" &&
            values?.[`${prefixName}_order_status`] === "draft" && (
              <>
                {
                  // (prefixName === "sott" || prefixName === "pot") &&
                  status && (
                    <AddButton
                      prefixIcon={false}
                      text="Edit"
                      type="button"
                      onclkFn={EditFn}
                      className="
                  flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
                  bg-[var(--primary-button-bg-color)] cursor-pointer
                  text-[var(--primary-button-fg-color)]
                  border border-[var(--primary-button-bg-color)]
                  hover:bg-[var(--primary-button-hover-color)]
                  text-[length:var(--primary-button-font-size)] 
                  font-[var(--primary-button-font-weight)]
                  "
                    />
                  )
                }
                <AddButton
                  prefixIcon={false}
                  text={"SHARE"}
                  className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-font-size)] 
font-[var(--primary-button-font-weight)]
"
                  type="button"
                  onclkFn={() => {
                    setIsModalOpen(id);
                  }}
                />
              </>
            )}
        </div>
      </div>
      <ShareTransactionModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        transaction={transaction}
        transaction_type={transaction_type}
      />
      <LoadingOverlay isLoading={buttonLoading} />
    </div>
  );
};

export default SalesPurchaseFooter;
export const tcsTdsOptns = [
  { label: "TCS", value: "tcs" },
  { label: "TDS", value: "tds" },
];
